<template>
    <div class="tsbx">
        <div class="tsbxc">
            <div class="gritem" @click="go($event)">
                <div class="gileft">
                    <img src="../../assets/wygl/crgl.png" alt="">
                    <span>出入管理</span>
                </div>
                <div class="giright">
                    <img src="../../assets/tsbx/you.png" alt="">
                </div>
            </div>
            <div class="gritem" @click="go($event)">
                <div class="gileft">
                    <img src="../../assets/wygl/ygpj.png" alt="">
                    <span>员工评价</span>
                </div>
                <div class="giright">
                    <img src="../../assets/tsbx/you.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
        }
    },
    created () {

    },
    mounted() {
        
    },
    methods: {
        
        go(event){
            var that =this
            var name = event.target.innerHTML
            if(name.indexOf('出入管理') != -1){
                this.$router.push({ path: "/wyfw/crgl", query: {} });
            }
            if(name.indexOf('业主缴费') != -1){
                 this.$router.push({ path: "/wyfw/wyjf", query: {} });
            }
            if(name.indexOf('员工评价') != -1){
                 this.$router.push({ path: "/wyfw/ygpj", query: {} });
            }
            if(name.indexOf('小区概况') != -1){
                 this.$router.push({ path: "/wyfw/wyjj", query: {} });
            }   
            if(name.indexOf('缴费记录') != -1){
                 // this.$router.push({ path: "/wyfw/wyjf", query: {} });
            }
        }
    },
}
</script>
<style lang="less">
    .tsbx{
        // height: 100%;
        width: 100%;
        display: flex;
        // background-color: #eeeeee;
        flex-direction: column;
        align-items: center;
        .tsbxc{
            width: calc(100% - 6%);
            .gritem{
                margin-top: 15px;
                height: 60px;
                width: 100%;
                display: flex;
                background: #fff;
                align-items: center;
                border-radius: 10px;
                justify-content: space-between;
                .gileft{
                    display: flex;
                    height: 100%;
                    align-items: center;
                    width: 50%;
                    img{
                        margin-left: 20px;
                    }
                    span{
                        margin-left: 10px;
                    }
                }
                .giright{
                    margin-right: 20px;
                    height: 100%;
                    align-items: center;
                    display: flex;
                    flex-direction:row-reverse;
                    img{
						display: block;
						height: 18px;
					}
                }
            }
        }
    }
</style>